import React from 'react';
import { Link } from 'react-router-dom';
import { Document, Page } from 'react-pdf';
import { useAuth0 } from '@auth0/auth0-react';
import './PDFViewer.css';

import { pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc =
    'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.8.69/build/pdf.worker.min.mjs';

const PDFViewer = ({ pdf }) => {
    const [currentPage, setCurrentPage] = React.useState(1);
    const [pageCount, setPageCount] = React.useState(null);
    const [active, setActive]=React.useState(false);
    const [success,setSuccess]=React.useState(false);
    const [link, setLink] = React.useState('order');
    const [intakeText, setIntakeText] = React.useState(<></>);
    const [noManualText, setNoManualText] = React.useState(<></>);
    const [error, setError] = React.useState(null);
    const [loading, setLoading] = React.useState(true);   // ✅ NEW

    const { user } = useAuth0();
    const servername = "https://api.myemployeemanual.com";

    async function handleLogin() {
        try {
            await fetch(
                `${servername}/addUser?userID=${user.sub}&email=${user.email}`,
                { method: 'POST' }
            );
        } catch (err) {
            console.error(err);
        }
    }

    async function handleIntakeButton() {
        try {
            const checkOrder = await fetch(`${servername}/checkOrder?userID=${user.sub}`);
            const checkActive = await fetch(`${servername}/checkActive?userID=${user.sub}&orderType=manual`);
            const checkOrderData = await checkOrder.json();
            const checkActiveData = await checkActive.json();

            if (!(checkOrderData.success || checkActiveData.active)) {
                setLink('order');
            } else {
                setLink('intake');
            }
            setActive(checkActiveData.active);
            setSuccess(checkOrderData.success);
            if (checkOrderData.success || checkActiveData.active) {
                setIntakeText(
                    <div className='alreadyBought'>
                        <Link to='/intake' className='intakeButton'>Customize your manual here!</Link>
                        <Link to="/order" className='buyAnother'>Buy another manual here.</Link>
                    </div>
                );
            } else if (pdf != null && (checkOrderData.success || checkActiveData.active)) {
                setIntakeText(
                    <div className='alreadyBought'>
                        <Link to='/intake' className='intakeButton'>Customize another manual here!</Link>
                        <Link to="/order" className='buyAnother'>Buy another manual here.</Link>
                    </div>
                );
            } else if (pdf != null) {
                setIntakeText(
                    <div className='alreadyBought'>
                        <Link to="/order" className='buyAnother'>Buy another manual here.</Link>
                    </div>
                );
            } else {
                setNoManualText(
                    <div className="noManual">
                        It seems you don't have a manual. Get one <Link to={`/${link}`}>
                            <p className='get'>here</p>
                        </Link>!
                    </div>
                );
            }
        } catch (err) {
            console.error(err);
        }
    }

    React.useEffect(() => {
        (async () => {
            setLoading(true);        // ✅ start loading
            await handleLogin();
            await handleIntakeButton();
            setLoading(false);       // ✅ end loading (PDF loading may continue)
        })();
    }, []);

    if (loading) {
        return (
            <div className="loadingContainer">
                <h2 style={{ color: "white" }}>Loading...</h2>
            </div>
        );
    }

    if (pdf == null || pdf === undefined) {
        return (
            <div className='noManualContainer'>
                {noManualText}
                {intakeText}
            </div>
        );
    }

    const onDocumentLoadSuccess = ({ numPages }) => {
        setPageCount(numPages);
        setError(null);
        if (numPages>0 && numPages!=null && !(active || success)) {
                setIntakeText(
                    <div className='alreadyBought'>
                        <Link to="/order" className='buyAnother'>Buy another manual here.</Link>
                    </div>
                );
            }
    };

    const onDocumentLoadError = (error) => {
        console.error("PDF load error:", error);
        setError(error.message);
    };

    const navHandler = (upper) => {
        if (upper && currentPage < pageCount) setCurrentPage(currentPage + 1);
        if (!upper && currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const downloadPDF = () => {
        const link = document.createElement('a');
        link.href = pdf;
        link.download = `manual_${user.sub}.pdf`;
        link.click();
    };

    return (
        <div className='pdfViewer'>
            <h1>Your Employee Manual</h1>

            <button
                onClick={downloadPDF}
                className='downloadButton'
                style={{
                    margin: '0.5em',
                    padding: '0.5em 2em',
                    backgroundColor: 'transparent',
                    color: 'white',
                    border: '3px solid white',
                    borderRadius: '50px',
                    fontFamily: 'Manrope, sans-serif',
                    fontWeight: 'bold',
                    fontSize: '1em',
                    cursor: 'pointer'
                }}
            >
                Download PDF
            </button>

            {error && (
                <div style={{ color: 'red', padding: '10px', marginBottom: '1em' }}>
                    Error: {error}
                </div>
            )}

            <div className='pdf'>
                <Document
                    file={pdf}
                    onLoadSuccess={onDocumentLoadSuccess}
                    onLoadError={onDocumentLoadError}
                    loading={<div style={{ color: 'white' }}>Loading PDF...</div>}
                    error={<div style={{ color: 'red' }}>Failed to load PDF.</div>}
                >
                    <Page
                        pageNumber={currentPage}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                    />
                </Document>
            </div>

            {pageCount && (
                <div className='pdfNav'>
                    <button onClick={() => navHandler(false)} disabled={currentPage <= 1}>← Previous</button>
                    <p>Page {currentPage} of {pageCount}</p>
                    <button onClick={() => navHandler(true)} disabled={currentPage >= pageCount}>Next →</button>
                </div>
            )}

            <div className='actionButtons'>
                {intakeText}
            </div>
        </div>
    );
};

export default PDFViewer;
